"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EquipmentCategory = void 0;
var EquipmentCategory;
(function (EquipmentCategory) {
    EquipmentCategory["heavy"] = "heavy";
    EquipmentCategory["light"] = "light";
    EquipmentCategory["marine"] = "marine";
    EquipmentCategory["vehicles"] = "vehicles";
    EquipmentCategory["lifing"] = "lifting";
    EquipmentCategory["teams"] = "teams";
})(EquipmentCategory = exports.EquipmentCategory || (exports.EquipmentCategory = {}));
//# sourceMappingURL=listing.js.map